import { render, staticRenderFns } from "./myCourse.vue?vue&type=template&id=12fd2e98&scoped=true&"
import script from "./myCourse.vue?vue&type=script&lang=js&"
export * from "./myCourse.vue?vue&type=script&lang=js&"
import style0 from "./myCourse.vue?vue&type=style&index=0&id=12fd2e98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd2e98",
  null
  
)

export default component.exports